import type { EntityConfiguration } from '@technocom/data/core';
import { DictionaryRef } from '@app/shared/models/dictionaries/dictionary-ref';

/**
 * Документы для проживания
 */
export class Residence extends DictionaryRef {
  static readonly options: EntityConfiguration = DictionaryRef.extendOptions({
    namespace: 'residence',
    title: 'Документы для проживания',
    serverUrl: '/dictionary/residence',
  });
}
